import * as React from 'react';
import { SVGProps } from 'react';

const IconSunSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 1a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0V1zm4.657 2.757a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707zm-9.9-1.414a1 1 0 0 0-1.414 1.414l.707.707A1 1 0 0 0 4.464 3.05l-.707-.707zM1 7a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2H1zm13 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm-1.05 4.536a1 1 0 0 0-1.414 1.414l.707.707a1 1 0 0 0 1.414-1.414l-.707-.707zm-8.486 0a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707a1 1 0 0 0 0-1.414zM9 14a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
    />
  </svg>
);
export default IconSunSizeS;
